// Диалог удаления нескольких элементов

import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-archive-items-dialog-component',
  template: `
    <section class="mat-typography">
      <app-dialog-header [drag]="true" (closeClicked)="dialogRef.close()">{{
        data.decorator.archiveGroupTitle
      }}</app-dialog-header>
      <mat-dialog-content>
        <div *ngFor="let str of data.decorator.toArchiveGroupMsg(data.count)">
          {{ str }}<br />
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <app-btn-dialog [mat-dialog-close]="{ok: true, item: data.item}"
          >ОК
        </app-btn-dialog>
        <app-btn-dialog (click)="dialogRef.close()">{{
          'cancel' | transloco
        }}</app-btn-dialog>
      </mat-dialog-actions>
    </section>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArchiveItemsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ArchiveItemsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
